<template>
  <div>
    <!-- edit outside events modal -->
    <!-- <modal
      name="edit-outside-event-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-outside-event
        title="Izlasci"
        :selectedDailyLog="selectedDailyLog"
        :employeeName="selectedName"
    /></modal> -->
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Pregled zaposlenih po sektorima</h2>
    </div>

    <div class="has-text-right is-size-7">
      <a @click="toggleActive">{{ stringOnlyActive }}</a>
    </div>

    <!-- Tabs -->
    <!-- <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': this.tabSelector === 0 }">
          <a @click="tabClicked(0)">Danas</a>
        </li>
        <li v-bind:class="{ 'is-active': this.tabSelector === 1 }">
          <a @click="tabClicked(1)">Juče</a>
        </li>
        <li :class="{ 'is-active': this.tabSelector === 2 }">
          <a @click="tabClicked(2)">Proizvoljan period</a>
        </li>
      </ul>
    </div> -->

    <!-- Time Span -->
    <!-- <div class="content" v-show="this.tabSelector === 2">
      <date-picker v-model="time3" @input="timeSpanChosen" range></date-picker>
    </div> -->

    <!-- Filter -->
    <!-- <h4 slot="title">Filteri...</h4> -->
    <div slot="content">
      <div>
        <div class="field">
          <label class="label">Izaberi sektor</label>
          <div class="control">
            <vue-select
              class="has-background-info-light"
              @option:selected="departmentSelected"
              type="text"
              label="name"
              :clearable="false"
              :options="departments"
              v-model="selectedDepartment"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic
        :params="params"
        @cell-click="tableCellClicked"
      ></vue-table-dynamic>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
// import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic";
// import DatePicker from "vue2-datepicker";
// import "vue2-datepicker/index.css";

// import EditOutsideEvent from "../parts/EditOutsideEvent.vue";
// import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
//import // getDepartmentFromEmployeeId,
// getDateFromTicks,
// "../../_helpers/arrangers";

export default {
  name: "EmployeeList",
  components: {
    VueTableDynamic,
    // DatePicker,
    // BulmaAccordion,
    // BulmaAccordionItem,
    // EditOutsideEvent,
  },
  data() {
    return {
      showOnlyActive: true,
      stringOnlyActive: "prikaži i neaktivne radnike",
      departmentData: null,
      departments: [],
      employees: [],
      selectedName: null,
      selectedDepartment: null,
      selectedDepartmentId: null,
      selectedEmployee: null,
      params: {
        data: [
          [
            "Index",
            "Ime",
            "Prezime",
            "Adresa",
            "Mobilni telefon",
            "Fix telefon",
            "Datum zapolsenja",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        columnWidth: [{ column: 0, width: "7%" }],
      },
    };
  },
  mounted() {
    this.getDepartments();
  },
  activated() {},
  methods: {
    tableCellClicked(row_id, column_id, cell_data) {
      if (column_id == 2) {
        // console.log(jedan);
        console.log(column_id);
        console.log(cell_data);
        console.log(this.params.data[row_id]);
      }
      if (column_id == 5) {
        this.selectedDailyLog = this.dailyLogs[row_id - 1];
        this.selectedName = this.params.data[row_id][2];
        this.$modal.show("edit-outside-event-modal");
      }
    },
    timeSpanChosen(span) {
      if (span[0] == null || span[1] == null) {
        return;
      }
      this.startDate = span[0];
      this.endDate = span[1];
    },
    departmentSelected(dep) {
      this.selectedDepartmentId = dep.id;
      console.log("sel");
      console.log(dep);
      this.getData(dep);
    },
    getDepartments() {
      UserService.getDepartments().then((response) => {
        // reset ui
        console.log(response.data);
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
        this.arrangeEmployees(response.data);
      });
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
          });
        });
      });
    },
    resetUi() {
      this.params.data = [
        [
          "Index",
          "Ime",
          "Prezime",
          "Adresa",
          "Mobilni telefon",
          "Fix telefon",
          "Datum zapolsenja",
        ],
      ];
      this.dailyLogs = [];
    },
    getData(departmentId) {
      // reset ui
      this.resetUi();

      let ndx = 1;

      console.log(departmentId);

      // populate table
      this.departmentData.forEach((department) => {
        if (department.departmentId == this.selectedDepartmentId) {
          department.employee.forEach((element) => {
            if (this.showOnlyActive) {
              if (element.status) {
                this.params.data.push([
                  ndx++,
                  element.firstName,
                  element.lastName,
                  element.address,
                  element.mobilePhone,
                  element.phone1,
                  element.startDate,
                ]);
              }
            } else {
              this.params.data.push([
                ndx++,
                element.firstName,
                element.lastName,
                element.address,
                element.mobilePhone,
                element.phone1,
                element.startDate,
              ]);
            }
          });
        }
      });
      this.params.data.push;
    },
    toggleActive() {
      console.log("toggling active!");
      console.log(this.showOnlyActive);
      this.showOnlyActive = !this.showOnlyActive;
      if (this.showOnlyActive) {
        this.stringOnlyActive = "prikaži i neaktivne radnike";
      } else {
        this.stringOnlyActive = "prikaži samo aktivne radike";
      }
      this.getData(this.selectedDepartmentId);
    },
  },
};
</script>
